import { ActionFlowModal } from './ActionFlowModal'
import { ActionFlowPage } from './ActionFlowPage'
import { ActionFlowButton } from './ActionFlowButton'
import { useActionFlow } from './useActionFlow'

export { ActionFlowModal } from './ActionFlowModal'
export { ActionFlowPage } from './ActionFlowPage'
export { ActionFlowButton } from './ActionFlowButton'
export { useActionFlow } from './useActionFlow'
export * from './types'

export const ActionFlow = {
  Modal: ActionFlowModal,
  Page: ActionFlowPage,
  Button: ActionFlowButton,
  useActionFlow,
} as const
